cv.ChangeEmailView = Marionette.LayoutView.extend({
  template : cv.Templates['change_email/view'],

  behaviors : [{
    behaviorClass : cv.FormBehavior,
		suppress_notifications: true
  }],

	bindings : {
    '#current_email' : {
      observe : 'email',
      update: function($el, value, model, options) {
        $el.val(model.get('email'))
      }
    }
	},

	events : {
	},

	validation: {
		current_password: [{
			required: true,
			msg: 'Please enter current password'
		}],
		email: [{
			required: true,
			msg: 'Required'
	  },{
			pattern: 'email',
			msg: 'Invalid e-mail'
	  }],
	  confirm_email: [{
			required: true,
			msg: 'Required'
	  },{
	    pattern: 'email',
	    msg: 'Invalid e-mail'
	  },{
	    equalTo: 'email',
	    msg: 'E-mails must match'
	  }]
	},

	templateHelpers: function(){
		return {
		}
	},

	initialize: function(options){
		this.options = _.extend(this.options, options);
		this.model = new Backbone.Model({
			current_password : '',
			email : '',
			confirm_email : ''
    });

		this.listenTo(this, 'form:saved', function(){
			$.ajax({
        url: cv.api_path + '/users/' + cv.user.get('id') + '/change_email',
        dataType: "json",
        data: {
					current_password : this.model.get('current_password'),
          email : this.model.get('email'),
          confirm_email : this.model.get('confirm_email')
        },
        type: "post",
        success: _.bind(function(data){
					this.$('input').val('');
					cv.user.set('email', this.model.get('email'));
					
          vent.trigger('notif:success', 'Your e-mail has been changed.');
        }, this),
        error: _.bind(function(data){
					var error = $.parseJSON(data.responseText);
          Backbone.Validation.error(this, error.attr, error.text);
          vent.trigger('notif:error', 'There was an error saving his form.');
        }, this)
      });
		}, this);

		console.log('ChangeEmailView initialized');
	},

	onAttach: function(){
		this.stickit(cv.user);
	},

	onDestroy: function(){
	}
});
